<template>
  <oie-my-pages-template :title="t('machineSettingsTitle')" :text="t('machineSettingsDescription')" :with-go-back="true">
    <oie-accordion-tabs ref="tabs">
      <oie-accordion-tab name="custom-machine-types" :display-name="t('customMachineSettingsTitle')">
        <oie-my-machines-custom-vehicle-data></oie-my-machines-custom-vehicle-data>
      </oie-accordion-tab>
      <oie-accordion-tab name="custom-machine-owners-and-fields" :display-name="t('customMachineOwnerSettingsTitle')">
        <oie-my-machines-custom-owners-fields></oie-my-machines-custom-owners-fields>
      </oie-accordion-tab>
    </oie-accordion-tabs>
  </oie-my-pages-template>
</template>

<script>
import tabs from '@/mixins/tabs'

export default {
  mixins: [tabs],
  mounted() {
    this.rememberTab(`my-machines-settings-tab`)
  }

}
</script>

<style lang="scss">

</style>
